import { useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId } from '@/libs/api-rest/generated/purchase-orders/purchase-orders';
// TODO(BE-PENDING): Uncomment after BE deploys GET /api/v3/purchase-orders/default-number/customers/{customer-id}
// and `npm run codegen:rest` has been re-run to regenerate the Orval hooks:
// import { useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerId } from '@/libs/api-rest/generated/purchase-orders/purchase-orders';

interface JobPOSettings {
  poRequired: boolean;
  defaultPoNumber: string | null;
  loading: boolean;
}

/**
 * Fetches hierarchy-resolved PO settings for a given customer + job-site pair.
 *
 * - When both IDs are known: calls the hierarchy endpoint (job-site settings override
 *   customer settings when both are configured in ERP).
 * - When only customerId is known: returns safe defaults until the BE ships a
 *   customer-only endpoint (see TODO below).
 */
export function useJobPOSettings(customerId: number | null | undefined, jobSiteId: number | null | undefined): JobPOSettings {
  const hasBothIds = !!(customerId && jobSiteId);

  // Hierarchy-resolved: requires both IDs. Fires when both are selected.
  const { data: hierarchyData, isLoading: hierarchyLoading } = useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerIdJobSitesJobSiteId(
    customerId as number,
    jobSiteId as number,
    { query: { enabled: hasBothIds } }
  );

  // TODO(BE-PENDING): Customer-level query — fires as soon as a customer is selected,
  // before a job site is chosen. Activate once BE deploys the new endpoint.
  //
  // Steps:
  //   1. BE adds GET /api/v3/purchase-orders/default-number/customers/{customer-id} to the API.
  //   2. Run `npm run codegen:rest` to regenerate Orval hooks.
  //   3. Uncomment the import at the top of this file.
  //   4. Uncomment the hook call below.
  //   5. Replace the final `return` in this function with the customerData return block.
  //
  // const { data: customerData, isLoading: customerLoading } =
  //   useGetApiV3PurchaseOrdersDefaultNumberCustomersCustomerId(
  //     customerId as number,
  //     { query: { enabled: !!customerId && !hasBothIds } }
  //   );

  if (hasBothIds) {
    return {
      poRequired: hierarchyData?.data?.required ?? false,
      defaultPoNumber: hierarchyData?.data?.defaultPoNumber ?? null,
      loading: hierarchyLoading
    };
  }

  // TODO(BE-PENDING): Replace this block with customerData once the hook above is activated:
  // return {
  //   poRequired: customerData?.data?.required ?? false,
  //   defaultPoNumber: customerData?.data?.defaultPoNumber ?? null,
  //   loading: customerLoading
  // };
  return { poRequired: false, defaultPoNumber: null, loading: false };
}
